import Vue from "vue";
import Vuex from "vuex";

import liquidacion from "./liquidacion.module";
import facturacionComision from "./facturacionComision.module";
import estadistica from "./estadistica.module";
import informe from "./informe.module";
import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import user from "./user.module";
import rol from "./rol.module";
import account from "./account.module";
import breadcrumbs from "./breadcrumbs.module";
import email from "./email.module";
import cajeroasignado from './cajeroasignado.module';
import ejecutivoCorredor from './ejecutivocorredor.module';
import periodoMovimiento from './periodoMovimiento.module';
import odata from './odata.booking.module';
import odata_facturacionComision from './odata.facturacionComision.module';
import odata_liquidacion from './odata.liquidacion.module';
import banco from "./banco.module";
import configuracion from './configuracion.module';
import retencion from './retencion.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    banco,
    odata,
    odata_facturacionComision,
    odata_liquidacion,
    liquidacion,
    facturacionComision,
    estadistica,
    informe,
    auth,
    htmlClass,
    config,
    user,
    rol,
    account,
    breadcrumbs,
    email,
    cajeroasignado,
    ejecutivoCorredor,
    periodoMovimiento,
    configuracion,
    retencion
  },
});
